import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { TitleText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroTitle = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <TitleText sizeMatch={['32', '64']} style={styles.text} bold>
      {children}
    </TitleText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.BROWN,
    marginBottom: theme.spacing['1'],
  },
});
